<ion-header>
  <app-header>
    <app-simple-button (click)="dismiss()" size="large" icon="close" slot="start" />
  </app-header>
</ion-header>

<ion-content>
  @if (item()) {
    <app-item-full [description]="description()" [price]="price()" [name]="name()" [imageSrc]="imageSrc()" />
  }
  
</ion-content>

<ion-footer>
  @if (isLoggedIn() && !hasAddress()) {
    <div class="no-address">
      <div>Please enter address to see local pharmacy catalogue.</div>
      <app-simple-button (click)="addAddress()" label="Enter your address" color="tint" [bold]="true" size="large" />
    </div>
  }
  <app-footer>
    @if (isLoggedIn() && hasAddress()) {
      <!-- TODO: This was removed at request -->
      <!-- <app-checkbox [(ngModel)]="swapEnabled" label="If unavailable, swap for a similar product"></app-checkbox> -->
      <app-counter [(ngModel)]="count"></app-counter>
      <app-button [label]="buttonLabel()"
        size="large"
        [isPrice]="true"
        [textRight]="getTotalPrice.toString()"
        (clicked)="addToCart()"
        />
    } @else {
      <app-button [disabled]="true" size="large" [label]="buttonLabel()" />
    }
    
    @if (!isLoggedIn()) {
      <p class="link">Please <span (click)="logIn()">Log in</span> or <span (click)="logIn()">Sign up</span> to create an order</p>
    }
  </app-footer>
</ion-footer>